import React from "react"
import styled from "~/ui/styled"
import { Text, Platform, Keyboard } from "~/ui/primitives"
import appleEmojiDatasource from "emoji-datasource-apple/emoji.json"
import googleEmojiDatasource from "emoji-datasource-google/emoji.json"

const Wrap = styled.div`
  width: 100%;
  height: min(280px, 36vh);
  max-height: min(280px, 36vh);
  flex-shrink: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
`

const EmojiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0;
  width: 100%;
  box-sizing: border-box;
`

const List = styled.FlatList`
  width: 100%;
`

const EmojisStyle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 44px;
  padding: 6px 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font: inherit;
  box-sizing: border-box;
`

const emojiDatasource = (Platform.OS === "ios" ? appleEmojiDatasource : googleEmojiDatasource)
  .filter((i) => i.category === "Smileys & Emotion")
  .reverse()
  .filter((i) => Number(i.added_in) <= 9)

const EmojiItem = ({ children, onClick }: { children: string; onClick: (emoji: string) => void }) => {
  const textStyle = { fontSize: 26, lineHeight: 1 }
  return (
    <EmojisStyle type="button" onClick={() => onClick(children)}>
      <Text style={textStyle}>{children}</Text>
    </EmojisStyle>
  )
}

interface Props {
  onSelect: (t: string) => void
}

const Emoji: React.FC<Props> = ({ onSelect }) => {
  const charFromUtf16 = (utf16: string) => String.fromCodePoint(...utf16.split("-").map((u) => "0x" + u))
  const charFromEmojiObject = (obj: string) => charFromUtf16(obj)
  const handleSelect = (emoji: string) => {
    onSelect(emoji)
  }

  if (Platform.OS === "web") {
    return (
      <Wrap>
        <EmojiGrid>
          {emojiDatasource.map((item) => (
            <EmojiItem key={item.unified} onClick={handleSelect}>
              {charFromEmojiObject(item.unified)}
            </EmojiItem>
          ))}
        </EmojiGrid>
      </Wrap>
    )
  }

  Platform.OS === "ios" && Keyboard.scheduleLayoutAnimation?.({ duration: 500 })
  const renderItem = ({ item }: { item: { unified: string } }) => {
    return <EmojiItem onClick={handleSelect}>{charFromEmojiObject(item.unified)}</EmojiItem>
  }
  return (
    <Wrap>
      <List
        numColumns={6}
        data={emojiDatasource}
        renderItem={renderItem}
        keyExtractor={(item) => item.unified}
      />
    </Wrap>
  )
}

export default Emoji
